import { Button, Col, Form, Input, Modal, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { createEntity, getEntities } from '../projects.reducer';


export const ProjectsUpdate = ({ isOpen, onClose, id }: any) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const isNew = id === undefined || id === null;

    const projectEntity = useAppSelector(state => state.projects.entity);
    const updating = useAppSelector(state => state.projects.updating);
    const updateSuccess = useAppSelector(state => state.projects.updateSuccess);

    const handleClose = () => {
        form.resetFields();
        onClose(updateSuccess);
    };



    useEffect(() => {
        if (updateSuccess) {
            handleClose();
        }
    }, [updateSuccess]);

    useEffect(() => {
        if (projectEntity && !isNew) {
            form.setFieldsValue(projectEntity);
        }
    }, [projectEntity]);


    const handleSubmit = values => {
        const oldData = !isNew && projectEntity;
        const entity = {
            ...oldData,
            ...values,
        };

        if (isNew) {
            dispatch(createEntity(entity));
        }
    };

    return (
        <Modal
            open={isOpen}
            maskClosable={false}
            onCancel={() => {
                onClose();
            }}
            footer={null}
            width={900}
        >
            <Container className="form">
                <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
                    <Title level={3}>{`${id ? 'Cập nhật thông tin' : 'Thêm mới'} dự án`}</Title>
                    <Row>
                        <Col md={24}>
                            <Form.Item label="Tên dự án" rules={[{ required: true, message: 'Hãy nhập tên dự án' }]} name={'name'}>
                                <Input className="w-100" size="large" placeholder="Nhập tên dự án" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={24}>
                            <Form.Item label="Ghi chú" rules={[{ required: true, message: 'Hãy nhập ghi chú' }]} name={'note'}>
                                <Input type="text" className="w-100" size="large" placeholder="Nhập ghi chú" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Row className="action mt-3" justify="end">
                            <Col>
                                <Button className="primary" htmlType="submit" disabled={updating}>
                                    Lưu
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className="secondary"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                >
                                    Hủy
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Container>
        </Modal>
    );
};

export default ProjectsUpdate;
